import React, { Component } from 'react';

import { Card, Icon, Modal, Button, Radio, Spin, Table, Popover } from 'antd';

import { inject, observer } from 'mobx-react';

import ContactusIcon from '../../../../../common/icons/ContactusIcon';

import moment from 'moment';

import './CommunicationCard.css';
import { api } from '../../../../../services';
import { pick } from 'lodash';

const Communications = ({ communications, commonStore }) =>
  communications.map(communication => (
    <div className="communications" key={communication.id}>
      <div className="typandmessage">
        <div className="type">
          {communication.direction === 'in' && <Icon type="arrow-down" theme="outlined" style={{ transform: 'rotate(45deg)' }} />}
          {communication.direction === 'out' && <Icon type="arrow-up" theme="outlined" style={{ transform: 'rotate(45deg)' }} />}
          <ContactusIcon type={communication.medium} />
        </div>
        <div className="message">{communication.message}</div>
      </div>
      <div className="datetime">
        {moment(communication.createdAt).format(commonStore.longDateFormat.L)} {moment(communication.createdAt).format(commonStore.longDateFormat.LT)}
      </div>
    </div>
  ));

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

@inject('translationsStore', 'commonStore')
@observer
export default class CommunicationCard extends Component {
  constructor(props) {
    super(props);

    const { commonStore } = this.props;
    this.historyTableColumns = [
      {
        dataIndex: 'createdAt',
        title: this.props.translationsStore.translate('carView.CommunicationCard.history.table.columns.createdAt'),
        sorter: true,
        sortOrder: false,
        width: 100,
        render: text => `${moment(text).format(commonStore.longDateFormat.L)} ${moment(text).format(commonStore.longDateFormat.LT)}`
      },
      {
        dataIndex: 'medium',
        title: this.props.translationsStore.translate('carView.CommunicationCard.history.table.columns.medium'),
        sorter: true,
        sortOrder: false,
        width: 70,
        render: text => this.props.translationsStore.translate(`carView.CommunicationCard.mediums.${text}`)
      },
      {
        dataIndex: 'direction',
        title: this.props.translationsStore.translate('carView.CommunicationCard.history.table.columns.direction'),
        sorter: true,
        sortOrder: false,
        width: 80,
        render: text => this.props.translationsStore.translate(`carView.CommunicationCard.direction.${text}`)
      },
      {
        dataIndex: 'message',
        title: this.props.translationsStore.translate('carView.CommunicationCard.history.table.columns.message'),
        sorter: true,
        sortOrder: false,
        render: text => <span style={{ width: 270, display: 'block', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{text}</span>
      }
    ];
    this.historyFetchMethods = [
      {
        key: 'communications',
        method: 'getCommunicationsHistory',
        defaultSorter: { field: 'createdAt', order: 'DESC' }
      }
    ];

    this.state = {
      showModal: false,

      sorters: { communications: this.historyFetchMethods[0].defaultSorter },
      lighboxVisibile: false,
      lightboxContent: ''
    };
  }

  loadHistory = (methods = ['communications'], page = 1) => {
    this.setState({
      historyLoading: true
    });
    const { carId } = this.props;
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };

  switchHistory = e => {
    this.loadHistory([e.target.value]);
  };

  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };

  render() {
    const { translationsStore, style, commonStore, communications, othercommunications } = this.props;
    const { sorters, historyActiveKey } = this.state;

    const historySwitch = this.historyFetchMethods.filter(item => ((this.state.historyResources || []).find(helper => helper.key === item.key) || {}).count > 0);
    const columns = this.historyTableColumns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {
        ...column,
        sortOrder
      };
    });

    return (
      <Card className="CommunicationCard" style={style} id="CommunicationCard">
        <div className="header">
          <div>{translationsStore.translate('carView.CommunicationCard.title')}</div>
          <Popover
            content={translationsStore.translate('carView.CommunicationCard.historyNoData.message')}
            title={translationsStore.translate('carView.CommunicationCard.historyNoData.title')}
            trigger="click"
            visible={this.state.historySum === 0 && this.state.historyNoDataHint}
            onVisibleChange={visible => this.setState({ historyNoDataHint: visible })}
          >
            <Button onClick={() => this.loadHistory()} type="primary">
              {translationsStore.translate('carView.history')}
            </Button>
          </Popover>
        </div>
        <div>
          {!!communications && communications.length > 0 && (
            <div className="communicationsWithOthers">
              <Communications communications={communications} commonStore={commonStore} />
              {!!othercommunications && othercommunications.length > 0 && (
                <a
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                  className="others"
                >
                  <div style={{ fontWeight: 'bold', color: 'black', textDecoration: 'underline' }}>
                    {translationsStore.translate('carView.CommunicationCard.othercommunications.message')} ({othercommunications.length})
                  </div>
                </a>
              )}
            </div>
          )}
          {(!communications || communications.length === 0) && <div>{translationsStore.translate('carView.CommunicationCard.noCommunications')}</div>}
        </div>
        <Modal
          title={translationsStore.translate('carView.CommunicationCard.othercommunications.title')}
          visible={this.state.showModal}
          footer={null}
          getContainer={() => document.getElementById('CommunicationCard')}
          onCancel={() => this.setState({ showModal: false })}
        >
          <Communications communications={othercommunications} commonStore={commonStore} />
        </Modal>
        <Modal
          title={translationsStore.translate('carView.CommunicationCard.history.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.historyShow}
          getContainer={() => document.getElementById('CommunicationCard')}
          footer={null}
          onCancel={() => this.setState({ historyShow: false })}
          centered={true}
        >
          <Spin spinning={this.state.historyLoading}>
            <div style={{ marginBottom: 20 }}>
              {historySwitch.length > 1 && (
                <RadioGroup onChange={this.switchHistory} defaultValue={historySwitch[0].key}>
                  {historySwitch.map((item, index) => (
                    <RadioButton key={index} value={item.key}>
                      {translationsStore.translate(`carView.CommunicationCard.history.panels.${item.key}`)}
                    </RadioButton>
                  ))}
                </RadioGroup>
              )}
            </div>
            {(this.state.historyResources || []).map(
              (item, index) =>
                item.count > 0 &&
                item.key === this.state.historyActiveKey && (
                  <Table
                    id="CommunicationCardHistory"
                    key={index}
                    dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
                    columns={columns}
                    pagination={item.pagination}
                    onChange={(...params) => this.handleTableChange(item.key, ...params)}
                    rowClassName="historyRow"
                    onRow={(record, rowIndex) => ({
                      onClick: event => {
                        this.setState({ lighboxVisibile: true, lighboxTitle: record.client, lighboxContent: record.message });
                      }
                    })}
                  />
                )
            )}
          </Spin>
        </Modal>
        <Modal title={this.state.lighboxTitle} visible={this.state.lighboxVisibile} footer={null} onCancel={() => this.setState({ lighboxVisibile: false })}>
          {this.state.lighboxContent}
        </Modal>
      </Card>
    );
  }
}
